import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ToastrService } from 'ngx-toastr';
import { Agent } from 'src/app/interfaces/agent.interface';
import { Violation, ViolationDetails } from 'src/app/interfaces/Violation.interface';
import { AgentListInfo } from 'src/app/services/agent.list.info';
import { AppConfig } from 'src/app/services/app.config.services';
import { TrsEventsService } from 'src/app/services/trsevents.service';
import { log } from 'src/app/utils/logging';

@Component({
  selector: 'app-events-filter',
  templateUrl: './events-filter.component.html',
  styleUrls: ['./events-filter.component.sass']
})
export class EventsFilterComponent implements OnInit {
  showEventFilter = false;

  events: any = {};
  violationsKeys: any = [];

  @Input() violations: any;
  @Input() AgentLanId: string;
  appConfig = AppConfig;
  searchText: string;

  filterEventHistoryLabel: string = "";
  searchEventLabel: string = "";
  applyLabel: string = "";
  clearLabel: string = "";
  applyFiltersLabel: string = "";
  clearFiltersLabel: string = "";

  constructor(private wsService: TrsEventsService, private translationService: TranslocoService, private agentListInfoService: AgentListInfo,
    private toastService: ToastrService, private trsService: TrsEventsService) {
    this.filterEventHistoryLabel = this.translationService.translate("Filter Event History");
    this.searchEventLabel = this.translationService.translate("Enter Event ID");
    this.applyLabel = this.translationService.translate("Apply");
    this.clearLabel = this.translationService.translate("Clear");
    this.applyFiltersLabel = this.translationService.translate("Apply Filters");
    this.clearFiltersLabel = this.translationService.translate("Clear Filters");
  }

  ngOnInit(): void {
    try {
      this.wsService.evtDataObservable.subscribe(response => {
        switch (response.eventName) {
          case "AGENT_CHANGED": this.agentSelected(); break;
          case "SELECTED_EVENT_FILTER":
            this.showEventFilter = !this.showEventFilter;
            if (this.showEventFilter === true)
              this.showFilterMenu();
            break;
        }
      });
    }
    catch (err) {
      log.error(``, err);
    }
  }

  showFilterMenu() {
    if (!this.violations) {
      return;
    }

    this.violations.forEach((violation: any) => {
      if (this.appConfig.settings.ChatEvents.includes(violation.ViolationName) === false) {
        if (this.events[violation.ViolationName] != null) {
          this.events[violation.ViolationName]["Count"]++;
        }
        else {
          this.events[violation.ViolationName] = {};
          this.events[violation.ViolationName]["Count"] = 1;
          this.events[violation.ViolationName]["checked"] = false;
          this.events[violation.ViolationName]["Show"] = true;
          this.events[violation.ViolationName]["EventName"] = violation.ViolationName;
        }
      }
    });

    this.violationsKeys = Object.keys(this.events);
  }

  closeSideNav() {
    this.searchText = '';
    this.showEventFilter = false;
  }

  toggleFilter() {
    this.showEventFilter = !this.showEventFilter;
  }

  filterEvent = async (closeSideNav: boolean = false) => {
    let eventsArr = [];

    if (this.searchText != null && this.searchText.trim() !== '') {
      if (Number.isNaN(Number(this.searchText)) === false) {
        const isEventIdFound: boolean = this.violations.every((violation: Violation) => {
          if (this.searchText === violation.EventId.toString())
            return false;
          else return true;
        })

        //Since Array.every returns true if all elements pass the test, we need to check if the eventId is not found in the array
        if (isEventIdFound === true) {
          //Check if all previous events are loaded, if it is already all loaded then that means the eventId is not present for this agent, saving an api call
          if (this.agentListInfoService.IsViolationHistoryLoadingComplete(this.AgentLanId) === false) {
            const details: ViolationDetails[] = await this.appConfig.GetViolationDetails(Number(this.searchText));

            if (details.length > 0 && details[0] != null && details[0].AgentId != null) {
              const agentInfo: Agent | undefined = this.agentListInfoService.GetAgentInfoFromAvayaLoginId(details[0].AgentId);

              if (agentInfo == null)
                //eventid does not exist, since agent info is not found
                this.toastService.error(`Event ID ${this.searchText} does not exist for agent ${this.AgentLanId}`);
              else {
                if (this.AgentLanId !== agentInfo.LanID) {
                  //eventid is not present for the current agent, but for some other agent
                  this.toastService.error(`Event ID ${this.searchText} does not exist for agent ${this.AgentLanId}`);

                  //Check if the violation is already present in the violation history of the agent
                  const doesViolationIdExist: boolean = this.trsService.events[agentInfo.LanID].some((existingValue: Violation) => existingValue.ViolationId === details[0].ViolationId);
                  if (doesViolationIdExist === false)
                    this.sendEvent("ADD_VIOLATION", {
                      "AgentLanId": agentInfo.LanID,
                      "ViolationDetails": details[0],
                    });
                }
                else {
                  this.sendEvent("ADD_VIOLATION", {
                    "AgentLanId": agentInfo.LanID,
                    "ViolationDetails": details[0],
                  });

                  eventsArr.push(this.searchText);
                }
              }
            }
            else
              //eventid does not exist
              this.toastService.error(`Event ID ${this.searchText} does not exist for agent ${this.AgentLanId}`);
          }
          else
            //eventid does not exist
            this.toastService.error(`Event ID ${this.searchText} does not exist for agent ${this.AgentLanId}`);
        }
        else eventsArr.push(this.searchText); //This indicates the eventId is present in the current agent's violation history
      }
    }


    for (let event in this.events)
      if (this.events[event].checked)
        eventsArr.push(event);

    if (closeSideNav === true)
      this.showEventFilter = false;

    this.sendEvent("FILTER_EVENT_BY_NAME", eventsArr);
  }

  clear() {
    this.searchText = '';
    this.sendEvent("FILTER_EVENT_BY_NAME", []);
    this.closeSideNav();

    //Clear the checkboxes on the events, so that if the event filter nav bar is opened again the same filter is not applied directly
    if (this.events != null) {
      for (const [key, value] of Object.entries(this.events)) {
        //@ts-ignore
        if (value.checked != null && value.checked === true) {
          //@ts-ignore
          value.checked = false;
        }
      }
    }
  }

  searching(text: string) {
    for (let event in this.events) {
      if (event.toLowerCase().indexOf(text.toLowerCase()) == -1) {
        this.events[event].Show = false;
      }
      else {
        this.events[event].Show = true;
      }
    }
  }

  sendEvent = (eventName: any, responseData: any): void => this.wsService.evtdata.next({
    "eventName": eventName,
    "data": responseData
  });

  agentSelected = (): void => {
    this.events = {};
    this.clear();
  }
}
